import { alpha, Theme } from '@mui/material/styles';
import { buttonIconMotionSx, primarySx } from '../../../components/ui/styleKit';
import { mcpInputSx } from '../../mcp/mcpUi';
import { simulateDialogZ } from './constants';

// Simulate opens over an already-dimmed drawer (50%) or dialog (70%); a light layer keeps
// the page near the usual dialog dim instead of stacking to black.
const NESTED_BACKDROP_ALPHA = 0.35;

// One height for every field, so the symbol search lines up with plain inputs (44px touch target).
const FIELD_HEIGHT_PX = 44;

export const simulateDialogSx = {
  zIndex: simulateDialogZ,
  '& .MuiBackdrop-root': { backgroundColor: alpha('#000', NESTED_BACKDROP_ALPHA) }
} as const;

/** The AI Connect input recipe at a fixed height; works for TextField, Select, Autocomplete and date pickers. */
export const simulateFieldSx = (theme: Theme) => {
  const base = mcpInputSx(theme);
  return {
    ...base,
    '& .MuiOutlinedInput-root': { ...base['& .MuiOutlinedInput-root'], height: FIELD_HEIGHT_PX }
  };
};

/** The dialog's main action button (Simulate, Simulate again, Try again). */
export const simulatePrimaryActionSx = (theme: Theme) => ({ ...primarySx(theme), ...buttonIconMotionSx, py: 1, px: 3 });
